import { useEffect, useState, useContext } from "react"
import { AuthContext } from "../../contexts/authContext";
import { getTreinamentos } from "../../components/Artigos/articlesService"
import { Link } from "react-router-dom";

type Material = {
  id: number;
  nome: string;
  tipo: string;
  caminho: string;
}

type TreinamentoProps = {
  id: number;
  titulo: string;
  descricao: string;
  carga_horaria: number;
  materiais: Material[];
}

const getFileExtension = (path: string): string | null => {
    const parts = path.split('.');
    if (parts.length > 1) {
        return parts.pop()!.toLowerCase();
    }
    return null;
};

export default function Treinamento() {
  const [treinamentos, setTreinamentos] = useState<TreinamentoProps[]>([]);
  const [loading, setLoading] = useState(true);

  useContext(AuthContext);
  const accessToken = localStorage.getItem('@seculos:token');  
  const token = accessToken ? JSON.parse(accessToken).accessToken : console.log("error na conversão do token-localSotrage");

  useEffect(() => {
    async function loadTreinamentos() {
      if(!token){
        console.warn("Token não encontrado");
        setLoading(false);
        return;
      }

      try {
        const data: TreinamentoProps[] = await getTreinamentos(token);
        console.log("Treinamentos carregados: ", data);
        setTreinamentos(data);
      } catch (error) {
        console.error("Erro ao buscar treinamentos.", error);
      } finally {
        setLoading(false);
      }
    }

    loadTreinamentos();

  }, [token]);

  if (loading) {
    return(
      <div className="flex justify-center items-center h-64 text-gray-500">
        Carregando treinamentos...
      </div>
    )
  }

  return (
    <>
      <section className="py-10 bg-gray-100">
        <div className="container mx-auto px-4">
          <h3 className="text-2xl font-bold mb-6 text-center text-gray-800">Treinamentos Disponíveis</h3>

          <div className="grid gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
            {treinamentos?.length > 0 ? (
              treinamentos.map((treinamento) => {
                const materialPreview: Material | undefined = treinamento.materiais.find((m) => {
                  const ext = getFileExtension(m.caminho);
                  return ext && ['jpg', 'jpeg', 'png'].includes(ext);
                }
              );

              const baseUrl: string = "http://localhost:5452/uploads/treinamento/";

              const previewUrl: string = materialPreview
                ? `${baseUrl}${materialPreview.caminho}`
                : "/default.jpg";

              return (
                <div
                  key={treinamento.id}
                  className="bg-white rounded-2xl shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 flex flex-col"
                >
                  <div className="relative h-40 bg-gray-200 flex justify-center items-center">
                    {materialPreview ? (
                      materialPreview.nome.match(/\.(jpg|jpeg|png|gif)$/i) ? (
                        <img
                          src={previewUrl}
                          alt={treinamento.titulo}
                          className="object-cover w-full h-full"
                        />
                      ) : materialPreview.nome.match(/\.mp4$/i) ? (
                        <video
                          src={previewUrl}
                          controls
                          className="object-cover w-full h-full"
                        />
                      ) : materialPreview.nome.match(/\.pptx$/i) ? (
                        <div className="flex flex-col items-center justify-center text-gray-600">
                          <i className="fa-solid fa-file-powerpoint text-4xl mb-2 text-orange-500"></i>
                          <span className="text-sm">Apresentação PPTX</span>
                        </div>
                      ) : null
                    ) : (
                      <div className="text-gray-400 text-sm">
                        Sem prévia disponível
                      </div>
                    )}
                  </div>                 

                  <div className="p-4 flex flex-col flex-grow">
                    <h4 className="text-lg font-semibold text-gray-800 mb-2">
                      {treinamento.titulo}
                    </h4>
                    <p className="text-sm text-gray-600 mb-3 line-clamp-3">
                      {treinamento.descricao}
                    </p>
                    <div className="flex justify-between items-center mb-3 text-sm text-gray-500">
                      <span>Carga horária:</span>
                      <span className="font-medium text-gray-700">
                        {treinamento.carga_horaria}h
                      </span>
                    </div>

                    <button className="mt-auto bg-blue-600 hover:bg-blue-700 text-sm font-medium py-2 px-4 rounded-lg transition-colors">
                      <Link to={`/painel/treinamentos/${treinamento.id}`}>
                          Acessar Treinamento
                      </Link>
                    </button>

                  </div>
                </div>
              );
            })

            ) : (
              <div className="flex">
                <p className="text-center text-gray-500">Nenhum treinamento encontrado</p>
              </div>
            )}

          </div>

        </div>
      </section>
    </>
  )
}